/** Pakistani Rupee formatting (en-PK locale). */
export const formatPkr = (value: number | null | undefined): string => {
  if (value == null || Number.isNaN(value)) {
    return 'PKR 0.00';
  }
  return `PKR ${value.toLocaleString('en-PK', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const formatCount = (value: number | null | undefined): string => {
  if (value == null || Number.isNaN(value)) {
    return '0';
  }
  return value.toLocaleString('en-PK', { maximumFractionDigits: 0 });
};
